const BO = {
  countryConfig: {
    accountHolderDocNumber: {
      label: "bankDetails.accountHolderDocNumber",
      placeholder: "bankDetails.documentCedulaPlaceholder",
      required: true,
      visible: true,
    },
    accountHolderName: {
      visible: false,
      label: "bankDetails.accountHolderName",
      required: false,
    },
    accountNumber: {
      visible: true,
      label: "bankDetails.accountNumber",
      required: true,
    },
    IBAN: {
      visible: false,
    },
    swift: {
      required: true,
      visible: true,
      label: "bankDetails.swift",
    },
    accountTypeBankDetails: {
      label: "bankDetails.accountTypeBankDetails",
      visible: true,
      required: true,
    },
    bankAddress: {
      visible: false,
      label: "bankDetails.bankAddress",
      required: false,
    },
    bankName: {
      visible: false,
      required: false,
      label: "bankDetails.bankName",
    },
  },
};
export { BO };
